<template>
  <lp-input
    :model-value="urlValue"
    :status="isValid ? 'neutral' : 'danger'"
    :message="isValid ? '' : t('LpUrlInput.UrlIsInvalid')"
    :preview="preview"
    @update:model-value="updateModelValue"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { t } from '@/plugins/i18n'

defineOptions({
  name: 'lp-url-input',
})

const emit = defineEmits(['update:model-value'])

interface Props {
  modelValue: string | null
  preview?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  preview: false,
})

const urlValue = computed(() => props.modelValue)

const isValid = computed(() => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ) // fragment locator
  return urlValue.value === '' || urlValue.value === null
    ? true
    : !!pattern.test(urlValue.value)
})
const updateModelValue = (value: string) => {
  emit('update:model-value', value)
}
</script>
